export default __webpack_public_path__ + "static/media/eggs.4e843caf.svg";